import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpApiService } from '../base/http-api.service';
import { ApiResponseModel } from '../../entities/api-response.model';
import { ProductModel } from '../../entities/product.model';

@Injectable({
    providedIn: 'root'
})

export class ProductService {

    constructor(
        public httpApiService: HttpApiService,
    ) {

    }

    public getProductsStock(): Observable<ApiResponseModel> {
        return this.httpApiService.httpGet('stock/products');
    }

    public get(uid): Observable<ApiResponseModel> {
        return this.httpApiService.httpGet('products/view', {uid});
    }

    public getById(id): Observable<ApiResponseModel> {
        return this.httpApiService.httpGet('products/view-by-id', {id});
    }

    public getByRecipeId(id): Observable<ApiResponseModel> {
        return this.httpApiService.httpGet('products/view-by-recipe', {id});
    }

    public set(product: ProductModel): Observable<ApiResponseModel> {
        return this.httpApiService.httpPost('products/store', product);
    }

    public delete(uid): Observable<ApiResponseModel> {
        return this.httpApiService.httpDelete('products/destroy', { uid });
    }

}
